import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent implements OnInit {

  @Input() messageText: string;
  @Input() icon: string;
  @Input() isConnected: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
